module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("67a22"))).then(() => parcelRequire('hEqeo'));